export default __webpack_public_path__ + "static/media/ProductSans-Bold.81ff770a.woff";